import { useEffect, useState } from "react";

// Owner previews only (protectFromSaving): no save menu on right-click or long-press, no
// dragging. This stops casual saving, not screenshots. Guest pages do not pass it.
const NO_SAVE_IMAGE_STYLE = { pointerEvents: "none", userSelect: "none", WebkitUserSelect: "none", WebkitTouchCallout: "none" };
const stopMenu = (event) => event.preventDefault();

const FileDisplay = ({ localState, source, setSource, withButton, onChangeFile, preparing = false, protectFromSaving = false }) => {
  const [filename, setFilename] = useState("");
  const [clear, setClear] = useState(false);

  useEffect(() => {
    let splitted = localState.split("/");
    setFilename(splitted);
  }, [localState, source]);
  useEffect(() => {
    if (clear) {
      setSource(null);
    }
  }, [clear]);
  const ChangeButtons = () => (
    <div className="d-flex flex-column align-items-center gap-2 mt-2">
      <button onClick={onChangeFile ? onChangeFile : () => setClear(true)} className="btn btn-primary">
        לשינוי קובץ הזמנה - לחצו כאן
      </button>
      <a
        href="https://www.flashback.co.il/he/300-2/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-decoration-underline text-primary"
        style={{ cursor: "pointer", fontSize: "0.95rem" }}
      >
        לשינוי תוכן ההזמנה, לחצו כאן
      </a>
    </div>
  );

  if(preparing)return <div className="invite-editor__empty-preview" role="status"><span className="spinner-border spinner-border-sm" aria-hidden="true" /><span>מכין את ההזמנה לתצוגה - נא להמתין</span></div>;

  if (filename.includes("image")) {
    return (
      <div className="col-12 d-flex flex-column justify-content-center align-items-center">
        <img
          src={source}
          className="previewActive rounded"
          {...(protectFromSaving ? { draggable: false, style: NO_SAVE_IMAGE_STYLE, onContextMenu: stopMenu } : {})}
        />
        {withButton ? <ChangeButtons /> : null}
      </div>
    );
  }
  if (filename.includes("video")) {
    return (
      <div className="col-12 d-flex flex-column justify-content-center align-items-center">
        <video
          autoPlay={true}
          controls
          src={source}
          className="previewActive rounded"
          {...(protectFromSaving ? { controlsList: "nodownload", disablePictureInPicture: true, onContextMenu: stopMenu, style: { WebkitTouchCallout: "none" } } : {})}
        />
        {withButton ? <ChangeButtons /> : null}
      </div>
    );
  }
  if (filename.includes("audio")) {
    return (
      <div className="col-12 d-flex flex-column justify-content-center align-items-center">
        <audio src={source} autoPlay={true} controls className="previewActive rounded" />
        {withButton ? <ChangeButtons /> : null}
      </div>
    );
  }
  return (
    <div className="col-12 d-flex flex-column justify-content-center align-items-center">
      <span className="">הקובץ אינו נתמך. אנא בחרו קובץ מתאים.</span>
    
        <div onClick={() => setClear(true)} className="pointer border border-warning p-2 rounded">
          לבחירת קובץ אחר לחצו כאן
        </div>
    </div>
  );

};

export default FileDisplay;
